import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';

@Injectable()
export class SearchSupplierService {

  constructor(public http:HttpClient) { }
  search_new_supplier(obj,server){
    return this.http.post(server+"/search_supplier",obj);  
  }//end requester_search_material
  
  search_list_contract(obj,server){
    return this.http.post(server+"/search_contract",obj);  
  }//end requester_search_material
  
  search_contract_file(obj,server){
    return this.http.post(server+"/search_contract_file",obj);  
  }//end requester_search_material
  
  

}
